<template>
	<div class="scene-wrapper">
		<SceneHeading :imgUrl="imgUrl" :altText="altText"/>
		<div class="slot-list-container">
			<div v-for="slot in slots" :key="slot.id" class="slot-group" @click="openTrickSelector(slot)">
				<h2 class="slot-heading"> {{ slot.name }}</h2>
				<div class="trick-slot">
					<TrickBasic
						class="trick"
						v-if="trickInSlot(slot)"
						v-bind="trickInSlot(slot)"
						@click.native.stop="remove(trickInSlot(slot))"
					/>
				</div>
			</div>
			<div class="trick-selector" v-if="activeSlot">
				<a href="#" class="close-btn" @click="close">&times;</a>
				<TrickList
					class="basic-grid"
					trickType="TrickBasic"
					:tricks="availableTricks"
					@trick-selected="select"
				/>
			</div>
		</div>
		<div :class="['wrapper-footer', { 'hide-button': activeSlot }]">
			<Button :action="set" :disabled="!canAdvance">It's Showtime</Button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from '@/components/base/Button';
import TrickList from '@/components/game/shop/TrickList';
import TrickBasic from '@/components/game/shop/TrickBasic';
import SceneHeading from '@/components/partials/SceneHeading';

export default {
	name: 'TrickSelector',
	components: {
		Button,
		TrickBasic,
		TrickList,
		SceneHeading,
	},
	data() {
		return {
			activeSlot: null,
			imgUrl: `/static/set-routine-title.svg`,
			altText: "Set Routine",
		};
	},
	computed: {
		...mapGetters("game", {
			slots: "performance/slots",
			trickInSlot: "performance/trickInSlot",
			tricksBySlot: "tricks/bySlot",
		}),
		availableTricks() {
			return this.tricksBySlot({ id: this.activeSlot });
		},
		canAdvance() {
			return Object.values(this.slots).every(((slot) => this.trickInSlot(slot)));
		},
	},
	methods: {
		select(trick) {
			if (trick.owned) {
				this.$store.dispatch(`game/performance/addTrick`, trick);
				this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
				this.activeSlot = null;
			}
		},
		remove(trick) {
			this.$store.dispatch(`game/performance/removeTrick`, trick);
			this.$store.dispatch("sound/fx/play", { id: "button_negative" });
		},
		openTrickSelector(slot) {
			this.activeSlot = slot.id;
			this.$store.dispatch("sound/fx/play", { id: "thought_bubble" });
		},
		close() {
			this.activeSlot = null;
			this.$store.dispatch("sound/fx/play", { id: "generic_wipe" });
		},
		set() {
			this.$router.push('/game/trick-selector/complete');
			this.$store.dispatch("sound/fx/play", { id: "set_routine" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.slot-list-container {
		display: flex;
		width: 100%;
		margin: 0 auto;
		justify-content: center;

		@include desktop { width: 1000px; }
	}

	.slot-group {
		width: 30vmin;
		max-width: 300px;
		text-align: center;
		margin: 0 2%;

		@include mobile { width: 40vmin; }
		@include desktop-sm { width: 35vmin; }
	}

	.slot-heading {
		color: $body-txt-color;
		font-family: $headline-font;
		font-size: $font-size-sm;
		text-transform: uppercase;
		line-height: 1;
		margin-bottom: 1em;

		@include mobile { font-size: $font-size-xx-sm; }
		@include desktop-lg { font-size: $font-size-lg; }
	}

	.trick-slot {
		height: 30vmin;
		max-height: 300px;
		border: 7px solid $off-white-dark;
		border-radius: $border-radius;
		padding: 2%;
		background-color: $primary-color-dark;
		background-image: url('~@/assets/images/plus-sign.svg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: 30%;
		transition: all $ui-transition-duration;

		@include mobile {
			height: 40vmin;
			border-width: 5px;
		}

		@include desktop { border-width: 10px; }

		@include desktop-sm {
			border-width: 7px;
			height: 35vmin;
		}

		&:hover {
			cursor: pointer;
			background-color: $primary-color;
		}
	}

	.trick.trick-wrapper {
		width: 100%;
		border: none;
		background: $alt-color;
	}

	.trick-selector {
		position: absolute;
		width: 75vw;
		height: 40vw;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		background: $alt-color;
		box-shadow: $box-shadow;

		@include desktop {
			width: 1000px;
			height: 500px;
		}

		.close-btn {
			position: absolute;
			top: -1ch;
			line-height: 1;
			right: -1ch;
			color: $off-white;
			text-decoration: none;
			font-size: 4em;

			@include mobile {
				right: unset;
				left: -1ch;
			}
		}
	}

	.hide-button {
		opacity: 0;
		pointer-events: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/game/scenes/TrickSelector.vue